// extracted by mini-css-extract-plugin
export default {"container":"MisAccesos_container__NtJTx","container_body":"MisAccesos_container_body__sL2C5","loadingContainer":"MisAccesos_loadingContainer__x3TWr"};